import { ESectionColor, Section } from '@web_opxp/components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch, Action } from 'redux';
import CloseButton from '../../components/CloseButton/CloseButton';
import ExtraModeItem from '../components/ExtraModeItem';
import { gameModeSelected, gameModeSelectionViewOpened } from '../firebaseActions';
import { ExerciseActions } from '../slice';
import { EExtraMode } from '../types';
import './ExtraModesPage.scss';

export default function ExtraModesPage() {
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  useEffect(() => {
    dispatch(gameModeSelectionViewOpened());
  }, [dispatch]);
  const closeExtraModes = () => dispatch(ExerciseActions.selectExtraMode(EExtraMode.None));
  const selectModeHandlerBuilder = (mode: EExtraMode) => () => {
    dispatch(gameModeSelected(mode));
    dispatch(ExerciseActions.selectExtraMode(mode));
  };
  return (
    <Section noPadding={true} color={ESectionColor.blue} className="exercise-section">
      <div className="view extra-modes-view">
        <CloseButton onClick={closeExtraModes} className="close-extra-modes-button" />
        <ul className="modes-container">
          <ExtraModeItem mode={EExtraMode.Challenger} onSelect={selectModeHandlerBuilder(EExtraMode.Challenger)} />
          <ExtraModeItem mode={EExtraMode.Survival} onSelect={selectModeHandlerBuilder(EExtraMode.Survival)} />
          <ExtraModeItem mode={EExtraMode.Learning} onSelect={selectModeHandlerBuilder(EExtraMode.Learning)} />
        </ul>
      </div>
    </Section>
  );
}
